import { payloadAsParam } from '../../signalr/helpers'
import type { InvokeDefinition } from '../../signalr/types'
import { setOrderError } from '../order/actions'
import type { OrderResponse } from '../order/types'
import type { ConfirmOrderAction, RejectOrderAction } from './actions'

export const rejectOrderDefinition: InvokeDefinition<
  [string],
  OrderResponse,
  RejectOrderAction
> = {
  method: 'RejectOrder',
  getParams: payloadAsParam,
  mapError: (_err, action) => setOrderError(action.payload)
}

export const confirmOrderDefinition: InvokeDefinition<
  [string, string],
  OrderResponse,
  ConfirmOrderAction
> = {
  method: 'ConfirmOrder',
  getParams: (_state, action) => [
    action.payload.id,
    action.payload.spotCrossSelection
  ],
  mapError: (_err, action) => setOrderError(action.payload.id)
}
